window.ConfirmButton = (function () {
    var awaiter = "m-await",
        textSelector = '.js-content-menu__single-button-text',
        idleTextAttr = 'data-idle-text',
        confirmTextAttr = 'data-confirm-text';

    return {
        init: function (selector, callback, ajaxUrl, ajaxSuccessCallback, ajaxData) {

            app.body.on('click', selector, function () {
                var that = $(this);
                textContainer = that.find(textSelector);
                if (that.hasClass(awaiter)) {

                    if (callback) {
                        callback();
                    }

                    if (ajaxUrl) {
                        Ajax.postJson(ajaxUrl, {
                            data: ajaxData,
                            doCallAjaxViewParsers: false,
                            success: function (resp) {

                                if (ajaxSuccessCallback) {
                                    ajaxSuccessCallback(resp);
                                }
                                that.removeClass(awaiter);
                                textContainer.text(that.attr(idleTextAttr));
                            }
                        });
                    }
                    else {
                        that.removeClass(awaiter);
                        textContainer.text(that.attr(idleTextAttr));
                    }
                    
                }
                else {
                    that.addClass(awaiter);
                    textContainer.text(that.attr(confirmTextAttr));
                    that.one('mouseleave', function (e) {
                        that.removeClass(awaiter);
                        textContainer.text(that.attr(idleTextAttr));
                    });
                }
                return false;

            });

        },
        dispose: function (selector) {
            app.body.off('click', selector);
        }

    }

}());